<template>
    <WindowBase 
        class="window-library" 
        :heading="heading" 
        :actions="actions">

        <div class="window-library__content">

            <div class="window-library__query">
                <v-text-field 
                    clearable 
                    hide-details  
                    color="color1" 
                    v-model="query">
                </v-text-field>
            </div>
            <div class="window-library__tags">
                <v-chip 
                    :color="isTagAll ? 'color1' : 'primary'"
                    @click="handleTag(keyTagAll)">
                    All
                </v-chip>
                <v-chip 
                    :color="isTagImported ? 'color1' : 'primary'"
                    @click="handleTag(keyTagImported)">
                    Imported
                </v-chip>
                <v-chip 
                    :color="isTagGenerated ? 'color1' : 'primary'"
                    @click="handleTag(keyTagGenerated)">
                    Generated
                </v-chip>
                <!--
                <v-chip 
                    :disabled="true">
                    Transparent
                </v-chip>
                -->
            </div>
            <div class="window-library__content">

                <AssetListScrollable 
                    v-if="isSynchronized"
                    :list="filteredAssets" 
                    :overflow="false" 
                    :selectable="true" 
                    :persist="true" 
                    :multiple="multiple" 
                    :max-assets="maxAssets" 
                    @select="handleSelect">
                </AssetListScrollable>

                <StateLoading v-else />

            </div>

        </div>

    </WindowBase>
</template>

<script>
import ASSETS from '@generio-ai/library-legacy/constants/assets'
import { mapGetters, mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import AssetListScrollable from '@/components/common/asset/AssetListScrollable.vue'
import StateLoading from '@/components/common/state/StateLoading.vue'
import WindowBase from './WindowBase.vue'

export default {
    name: 'WindowLibrary',
    components: {
        AssetListScrollable,
        StateLoading,
        WindowBase
    },
    props: {
        type: {
            type: String,
            default: ASSETS.TYPES.IMAGE
        },
        maxAssets: {
            type: Number,
            default: null
        },
        callback: {
            type: Function,
            default: null
        }
    },
    data() {
        return {
            query: '',
            tag: null,
            selected: []
        }
    },
    computed: {
        ...mapGetters('assets', [
            'isSynchronized'
        ]),
        ...mapGetters('flows', [
            'queryAsset',
        ]),
        ...mapGetters('library', [
            'getFilteredImageAssets',
            'getFilteredModelAssets'
        ]),

        keyTagAll() {
            return 'all'
        },
        keyTagImported() {
            return 'imported'
        },
        keyTagGenerated() {
            return 'generated'
        },
        keyTagTransparent() {
            return 'transparent'
        },

        isTypeImage() {
            return this.type === ASSETS.TYPES.IMAGE
        },
        isTypeModel() {
            return this.type === ASSETS.TYPES.MODEL
        },

        isTagAll() {
            return this.tag === this.keyTagAll
        },
        isTagImported() {
            return this.tag === this.keyTagImported
        },
        isTagGenerated() {
            return this.tag === this.keyTagGenerated
        },
        isTagTransparent() {
            return this.tag === this.keyTagTransparent
        },

        hasSelection() {
            return this.selected.length > 0
        },

        multiple() {
            return this.isTypeImage
        },

        heading() {
            if (this.isTypeImage) return 'Choose Images'
            if (this.isTypeModel) return 'Choose Model'
            return 'Choose Asset'
        },

        images() {
            return this.getFilteredImageAssets
        },
        models() {
            return this.getFilteredModelAssets
        },
        assets() {
            if (this.isTypeImage) return this.images
            if (this.isTypeModel) return this.models
            return []
        },
        filteredAssets() {
            const queriedAssets = this.assets.filter(asset => {
                if (!this.query || this.query.trim() === '') return true
                const query = this.query.trim().toLowerCase()
                return this.queryAsset(asset, query)
            })

            return queriedAssets.filter(asset => {
                if (this.isTagAll) return true
                if (this.isTagImported) return asset.generated === false
                if (this.isTagGenerated) return asset.generated === true
                return false
            })
        },
        actions() {
            return [
                {
                    label: 'Cancel',
                    handler: () => this.close()
                },
                {
                    color: 'color1',
                    label: this.multiple ? 'Continue (' + this.selected?.length + ')' : 'Continue',
                    disabled: !this.hasSelection,
                    handler: () => this.handleContinue()
                }
            ]
        }
    },
    methods: {
        ...mapActions('windows', [
            'close'
        ]),
        handleTag(tag) {
            this.tag = tag
        },
        handleSelect(asset, selected) {
            this.selected = selected || []
        },
        handleCLose() {
            this.close()
        },
        handleContinue() {
            if (this.callback && typeof this.callback === 'function') {
                this.callback(this.selected)
            }
            this.close()
        }
    },
    mounted() {
        this.tag = this.keyTagAll
    }
}
</script>

<style scoped>
.window-library__content {
    height: 100%;
    padding: 20px;
    padding-bottom: 0px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

.window-library__query {
    margin-bottom: 10px;
}

.window-library__tags {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

@media (max-width: 800px)
{
    .window-library__content {
        padding: 10px;
        padding-bottom: 0px;
    }

    .window-library__query {
        margin-bottom: 0px;
    }

    .window-library__tags {
        display: none;
    }
}

@media (max-width: 600px)
{
    .window-library__content {
        padding: 5px;
        padding-bottom: 0px;
    }
}
</style>